import React from 'react';
import useDynamicLogo from '../../hooks/useDynamicLogo';
import { DEFAULT_LOGO_URL } from '../../utils/imageUrlHelper';

/**
 * Componente que muestra el logo dinámico
 * Carga el logo desde la BD si existe, o usa el default
 */
const DynamicLogo = ({ alt = "Logo", className = "" }) => {
  const { logoUrl, isLoading } = useDynamicLogo();

  if (isLoading) {
    // Mostrar logo default mientras carga
    return <img src={DEFAULT_LOGO_URL} alt={alt} className={className} />;
  }

  return <img src={logoUrl} alt={alt} className={className} onError={(e) => {
    e.target.src = DEFAULT_LOGO_URL;
  }} />;
};

export default DynamicLogo;

